import React, { useState, useEffect } from "react";
import { createTwister, updateTwister } from "./adminTongueTwisterService";

const difficultyOptions = ["Easy", "Medium", "Hard"];

const TongueTwisterForm = ({ data, onSaved, onCancel }) => {
  const isEdit = !!data;

  const [form, setForm] = useState({
    title: "",
    description: "",
    pronunciation: "",
    difficulty: "Easy",
    youtubeLink: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (data) {
      setForm({
        title: data.title || "",
        description: data.description || "",
        pronunciation: data.pronunciation || "",
        difficulty: data.difficulty || "Easy",
        youtubeLink: data.youtubeLink || "",
      });
    }
  }, [data]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!form.title || !form.description) {
      alert("Title and Description are required");
      return;
    }

    const payload = {
      ...form,
      ...(form.youtubeLink ? {} : { youtubeLink: undefined }),
    };

    setLoading(true);
    const res = isEdit
      ? await updateTwister(data.id, payload)
      : await createTwister(payload);

    if (res.status === 200 || res.status === 201) {
      onSaved();
    } else {
      alert(res.message || "Operation failed");
    }
    setLoading(false);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="form-card" style={{ margin: 0, boxShadow: "none" }}>
          <h2>{isEdit ? "Edit" : "Create"} Tongue Twister</h2>

          <div className="form-group">
            <label>Title *</label>
            <input
              name="title"
              placeholder="e.g. She Sells Seashells"
              value={form.title}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Description *</label>
            <textarea
              name="description"
              placeholder="The full tongue twister text..."
              value={form.description}
              onChange={handleChange}
              rows={3}
            />
          </div>

          <div className="form-group">
            <label>Pronunciation</label>
            <textarea
              name="pronunciation"
              placeholder="e.g. Shee selz see-shelz by thuh see-shore."
              value={form.pronunciation}
              onChange={handleChange}
              rows={2}
            />
          </div>

          <div className="form-group">
            <label>Difficulty</label>
            <select
              name="difficulty"
              value={form.difficulty}
              onChange={handleChange}
            >
              {difficultyOptions.map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>YouTube Link (optional)</label>
            <input
              name="youtubeLink"
              placeholder="https://youtube.com/..."
              value={form.youtubeLink}
              onChange={handleChange}
            />
          </div>

          <div className="form-actions">
            <button onClick={handleSubmit} disabled={loading}>
              {loading ? "Saving..." : isEdit ? "Update" : "Create"}
            </button>
            <button onClick={onCancel} disabled={loading}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TongueTwisterForm;
